// 英文
export default {
  'menu.login': 'Login',
  'menu.home': 'Home',
  'menu.workplace': 'Workplace',
  'menu.setting': 'Setting',
  'menu.logout': 'Logout',
  'menu.setting.basic': 'Basic',
  'menu.setting.security': 'Security',
  'menu.system': 'System',
  'menu.system.admin-list': 'Admin List',
  'menu.system.role-list': 'Role List',
  'menu.system.func-list': 'Function List',
  'menu.system.error-log-list': 'Error Log',
  'menu.system.product-list': 'Products',
  'menu.system.cache-manage': 'Cache',
  'menu.member': 'Members',
  'menu.member.user-list': 'User List',
  'menu.member.user-account-list': 'Account Records',
  'menu.member.user-recharge-list': 'Recharge Records',
  'menu.member.user-cashout-list': 'Withdrawal List',
  'menu.agent': 'Agents',
  'menu.agent.list': 'Agent List',
  'menu.agent.account-list': 'Account Flow',
  'menu.agent.recharge-list': 'Recharge Records',
  'menu.op': 'Operations',
  'menu.op.bet-list': 'Bet Records',
  'menu.op.lotto-list': 'Draw Results',
  'menu.op.lotto-bet-setting': 'Odds Settings',
}